import { render, staticRenderFns } from "./ProjectsLayout.vue?vue&type=template&id=32e60341"
import script from "./ProjectsLayout.vue?vue&type=script&lang=js"
export * from "./ProjectsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports